import {observer} from "mobx-react";
import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import React from "react";
import CheckBoxWithLabel from "@dropDesk/presentation/components/check_box/check_box_with_label";

const CheckBoxOnlySectorListSearch = observer(
    ({
         setListOnlySectorEmpty,
         listOnlySectorEmpty,
         loading
     }: {
        setListOnlySectorEmpty: (value: boolean, withList?: boolean) => void,
        listOnlySectorEmpty: boolean
        loading: boolean,
    }) => {

        const appController = useInjection(AppController);

        return (
            <>
                {!appController.isUserClient && appController.user?.permissionAdmin &&
                        <CheckBoxWithLabel
                            label={'Somente sem setor'}
                            height={20}
                            checked={listOnlySectorEmpty}
                            disabled={loading}
                            onChange={(event) => setListOnlySectorEmpty(event.target.checked)}
                            name={'listOnlySectorEmpty'}
                            useDisplayInLineBlock={true}
                            tooltip={`Filtro utilizado para pesquisar os contatos que entraram em 
                                    contato pelo whatsapp e não selecionaram um setor`}
                        />
                }
            </>
        )
    })
export default CheckBoxOnlySectorListSearch;
